import { PortfolioCreditLoss } from "@pages/portfolio/credit-loss/credit-loss";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/portfolio/credit-loss")({
	component: PortfolioCreditLoss,
});
